module.exports = __webpack_public_path__ + "img/hazardCategory8.7e15a3ee.png";